import { AccountCircleOutlined, Add, ArrowBackOutlined, ArrowRightAlt, Clear, Close, Delete, Description, Edit, FilterAltOutlined, FilterOutlined, FolderOutlined, FolderSpecial, FolderSpecialTwoTone, KeyboardOutlined, MoreHoriz, Search } from '@mui/icons-material';
import { Avatar, Box, Breadcrumbs, Button, Chi, FormControlLabel, Radiop, CircularProgress, Divider, Fab, FormControl, Icon, IconButton, InputAdornment, InputLabel, MenuItem, Popover, Select, TextField, Typography, useMediaQuery, useTheme, Card, Skeleton, Tabs, Tab } from '@mui/material'
import { useApplicationContext } from '../../context/ApplicationContext';
import { useEffect, useState } from 'react';
import { grey, purple } from '@mui/material/colors';
import { font } from '../../styles/font';

import CreateProjectDrawer from './Create';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LightTooltip } from '../styled/CustomComponent';
import EditProjectDrawer from './Edit';
import { addProject_API, deleteProject_API, getProjectCategoryList_API, getProjectList_API, getProjectSubcategoryList_API, updateProject_API } from '../../api/controller/ProjectController';
import { Entity_Label, ModulePath, Severity } from '../../constant/ApplicationVariables';
import { HttpStatusCode } from 'axios';
import useErrorHandler from '../../api/errorHandler/useErrorHandler';
import DeleteProjectDialog from '../dialog/DeleteProjectDialog';
import { useTranslation } from 'react-i18next';
import { useHotkeys } from 'react-hotkeys-hook';

import { KeyboardKeys, KeyboardShortcuts } from '../../constant/KeyboardKeys';
import { debounce } from '../../utils/Functions';
import { forwardRef } from 'react';
import { VirtuosoGrid } from 'react-virtuoso';
import ProjectsContainer from '../projects';

import ProgramCard from './OrganisationCard';
import CreateProgramComponent from './Create';
import DeleteConfirmationDialog from '../dialog/DeleteConfirmationDialog';
import ActiveOrganisationContainer from './ActiveOrganisation';

export default function OrganisationContainer() {
    const {
        handleSnackbar,
        headerSearchText,
        setHeaderSearchText,
        programList,
        setProgramList,
        currentProgramData,
        setCurrentProgramData,
        openCreateProgramDrawer,
        setOpenCreateProgramDrawer,
        openEditProgramDrawer,
        setOpenEditProgramDrawer,
        openDeleteProgramDialog,
        setOpenDeleteProgramDialog,
    } = useApplicationContext();
    const theme = useTheme();
    const navigate = useNavigate();
    const errorHandler = useErrorHandler();
    const { t } = useTranslation('translation', { keyPrefix: 'project' });
    useHotkeys(KeyboardShortcuts.project.create, (e) => handleOpenCreateDialog());

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.up("sm") && theme.breakpoints.down("md"));
    const isLaptop = useMediaQuery(theme.breakpoints.up("md") && theme.breakpoints.down("lg"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg") && theme.breakpoints.down("xl"));
    const isLargeDisplay = useMediaQuery(theme.breakpoints.up("xl"));


    const [isLoading, setIsLoading] = useState(false);

    let dummyList = [
        {
            name: "Organisation 1",
            description: "Organisation Description 1",
        },
    ]



    const handleOpenItem = (itemData) => {
        setCurrentProgramData(itemData);
    }

    const handleCloseItem = () => {
        setCurrentProgramData(null);
    }

    const handleOpenItemEdit = (itemData) => {
        setCurrentProgramData(itemData);
        setOpenEditProgramDrawer(true);
    }

    const handleCloseItemEdit = () => {
        setOpenEditProgramDrawer(false);
        setCurrentProgramData(null);
    }

    const handleOpenCreateDialog = () => {
        setOpenCreateProgramDrawer(true);
    }

    const handleCloseCreateDialog = () => {
        setOpenCreateProgramDrawer(false);
    }


    const handleDeleteItem = (itemData) => {
        setCurrentProgramData(itemData);
        setOpenDeleteProgramDialog(true);
    }

    const handleCloseDeleteItem = () => {
        setOpenDeleteProgramDialog(false);
        setCurrentProgramData(null);
    }


    const handleKeyDown = (e, project) => {
        if (e.key === "Enter") {
            handleOpenItem(project);
        }
        if (e.key === "Delete") {
            handleDeleteItem(project);
        }
        if (e.key === "F2") {
            handleOpenItemEdit(project);
        }
    }




    const handleFilterProject = (item, index) => {
        return true
    }

    const handleProjectSearchFilter = (item, index) => {
        if (headerSearchText) {
            return item.name?.toLowerCase().includes(headerSearchText?.toLowerCase())
        } else {
            return item
        }
    }



    const handleGetItemsList = async () => {
        try {
            setIsLoading(true);

            const response = await getProjectList_API();
            console.log(response, "response handleGetItemsList")

            if (response) {
                errorHandler(response, setIsLoading);
            }

            if (response.status === HttpStatusCode.Ok) {
                setProgramList(response.data);
            }

        } catch (error) {
            console.log(error, error?.message, "projectreponse errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 1000);
        }
    }

    const handleCreateItem = async (projectData) => {
        if (!projectData?.name || !projectData?.description || !projectData?.categoryName || !projectData?.subCategoryName) {
            return handleSnackbar("Please fill all the fields", Severity.error)
        }

        try {
            // setIsLoading(true);

            let body = { ...projectData };

            const response = await addProject_API(body);

            if (response.status === HttpStatusCode.Ok) {
                handleGetItemsList();
                handleCloseCreateDialog();
                // handleSnackbar(response.message, Severity.success)
            }

            if (response) {
                errorHandler(response, setIsLoading);
            }

            setTimeout(() => {
                // setIsLoading(false);
            }, 1000);

            console.log(response, "projectreponse data");
        } catch (error) {
            console.log(error, "projectreponse errorr");
        }
    }

    const handleUpdateProject = async (projectData) => {
        if (!projectData?.name || !projectData?.description || !projectData?.categoryName || !projectData?.subCategoryName) {
            return handleSnackbar("Please fill all the fields", Severity.error)
        }

        try {
            setIsLoading(true);

            // let body = { ...projectData };

            let body = {
                // "newName": projectData?.name,
                "currentName": currentProgramData?.name,
                "lastModifiedAt": currentProgramData?.lastModifiedAt ? currentProgramData?.lastModifiedAt : null,
                // "categoryName": projectData?.categoryName,
                // "subCategoryName": projectData?.subCategoryName,
                // "description": projectData?.description,
                // "status": "Archive"
                // "status" : projectData?.status
            }

            if (projectData?.name !== currentProgramData?.name) {
                body.newName = projectData?.name
            }
            if (projectData?.description !== currentProgramData?.description) {
                body.description = projectData?.description
            }

            if (projectData?.categoryName !== currentProgramData?.categoryName) {
                body.categoryName = projectData?.categoryName
            }
            if (projectData?.subCategoryName !== currentProgramData?.subCategoryName) {
                body.subCategoryName = projectData?.subCategoryName
            }

            if (projectData?.status !== currentProgramData?.status) {
                body.status = projectData?.status
            }

            if (projectData?.useCasePrefix !== currentProgramData?.useCasePrefix) {
                body.useCasePrefix = projectData?.useCasePrefix
            }

            if (projectData?.userStoryPrefix !== currentProgramData?.userStoryPrefix) {
                body.userStoryPrefix = projectData?.userStoryPrefix
            }

            if (projectData?.testCasePrefix !== currentProgramData?.testCasePrefix) {
                body.testCasePrefix = projectData?.testCasePrefix
            }

            const response = await updateProject_API(body);

            if (response.status === HttpStatusCode.Ok) {
                handleGetItemsList();

                let list = [...programList];
                let foundIndex = list?.findIndex((item) => item?.name === body.currentName);
                if (foundIndex !== -1) {
                    list[foundIndex] = response.data;
                }
                setProgramList(list);


                handleCloseItemEdit();
            }

            if (response) {
                errorHandler(response, setIsLoading);
            }

            // setTimeout(() => {
            //     setIsLoading(false);
            // }, 1000);

            console.log(response, "projectreponse data");
        } catch (error) {
            console.log(error, "projectreponse errorr");
        }
    }

    const handleDelete = async () => {
        try {


            let query = `name=${currentProgramData?.name}`

            const response = await deleteProject_API(query);
            console.log(response, "response handleDelete")

            if (response) {
                errorHandler(response);
            }

            if (response.status === HttpStatusCode.Ok) {
                handleGetItemsList();
                handleCloseDeleteItem();
                handleSnackbar(response.message, Severity.success)
            }


        } catch (error) {
            console.log(error, error?.message, "projectreponse errorr");
            handleSnackbar(String(error), Severity.error);
        } finally {
            setTimeout(() => {

            }, 1000);
        }
    }

    useEffect(() => {
        setProgramList(dummyList);
        if (programList?.length === 0) {
            handleGetItemsList();
        }
    }, [programList?.length]);


    console.log(isMobile, isTablet, isLaptop, isDesktop, isLargeDisplay, "isMobile isTablet isLaptop isDesktop isLargeDisplay");


    if (currentProgramData) {
        return (
            <ActiveOrganisationContainer />
        )
    }

    return (
        <Box className=" flex flex-col gap-6 px-0 py-0 relative h-full w-full overflow-hidden " >


            {/* {!openStoryPreview && !openStoryConfirmationPreview &&
                <Box className="absolute bottom-0 right-0 z-10">
                    <LightTooltip title={<Box className="flex items-center gap-2">
                        <Typography fontSize={font.size.fs_5} color="textPrimary">{t("createProject")}</Typography>
                        <ShortcutText keyboardShortcutText={KeyboardKeys.N} textColor={"textSecondary"} />
                    </Box>}>
                        <Fab

                            color="secondary"
                            onClick={handleOpenCreateDialog}
                            style={{ boxShadow: "none" }}>
                            <Add />
                        </Fab>
                    </LightTooltip>
                </Box>} */}


            {/* page description */}
            {/* <Box className="flex items-center justify-between w-full h-fit px-4 py-0">

            
                <Box className="flex-1 flex flex-col">
                    <Typography fontSize={font.size.fs_2} color="textPrimary" fontWeight={"bold"}>{handlePageDetails()?.title}</Typography>
                    <Typography>{handlePageDetails()?.description}</Typography>
                </Box>

                <Button startIcon={<Add />} variant="contained" color="secondary" onClick={handleOpenCreateDialog}>Create Project</Button>
            </Box> */}


            {/* header */}
            <Box className="w-full h-fit flex justify-between sticky top-0 z-10 backdrop-blur-sm px-4 py-0">
                <Header projectsList={programList?.filter(handleFilterProject)?.filter(handleProjectSearchFilter)} isLoading={isLoading} setIsLoading={setIsLoading} />
            </Box>


            {/* items list */}
            <Box className="  grow flex flex-col overflow-hidden " >


                {isLoading ? (
                    <Box className="w-full h-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 px-4 py-0 overflow-y-auto">
                        {/* <CircularProgress /> */}
                        {/* <Typography fontSize={font.size.fs_5}>Loading...</Typography> */}
                        {
                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item, index) => {
                                return (
                                    <Skeleton key={index} variant="rounded" width="100%" height={"100%"} animation="wave" />
                                )
                            })
                        }
                    </Box>
                )
                    : programList?.length === 0 ?
                        <Box className="grow flex flex-col gap-2 justify-center items-center ">
                            <Description sx={{ fontSize: font.size.fs_1 }} />
                            <Typography fontSize={font.size.fs_5}>{t("notFoundMessage")}</Typography>
                        </Box>
                        :
                        (
                            programList
                                ?.filter(handleFilterProject)
                                ?.filter(handleProjectSearchFilter)?.length === 0 ?
                                (
                                    <Box className="grow flex flex-col gap-0 justify-center items-center ">
                                        <FolderSpecialTwoTone color="secondary" sx={{ fontSize: font.size.fs_1 }} />
                                        <Typography fontSize={font.size.fs_4}>{t("notFoundMessage")}</Typography>
                                    </Box>
                                ) :

                                (
                                    <>
                                        <Box className="flex flex-col gap-2 w-full  px-4 overflow-y-auto">
                                            <VirtuosoGrid
                                                data={programList
                                                    ?.filter(handleFilterProject)
                                                    ?.filter(handleProjectSearchFilter)
                                                    ?.sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt))}
                                                totalCount={programList
                                                    ?.filter(handleFilterProject)
                                                    ?.filter(handleProjectSearchFilter)
                                                    ?.sort((a, b) => new Date(b?.createdAt) - new Date(a?.createdAt)).length}
                                                initialItemCount={10}
                                             //   overscan={10}
                                                style={{
                                                    height: '100vh',
                                                    display: 'grid',
                                                    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 240px), 1fr))',
                                                    gap: 2,
                                                    // padding: 2, // theme.spacing(2)
                                                }}
                                                components={{
                                                    List: forwardRef(({ style, ...props }, ref) => (
                                                        <div
                                                            ref={ref}
                                                            {...props}
                                                            style={{
                                                                ...style,
                                                                display: 'grid',
                                                                gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 240px), 1fr))',
                                                                gap: '1rem',
                                                                // padding: '1rem',
                                                                width: '100%'
                                                            }}
                                                        />
                                                    ))
                                                }}

                                                itemContent={(index, itemData) => (
                                                    <Box
                                                        key={`project-card ${itemData?.name}`}
                                                        aria-label={`Project Card ${itemData?.name}`}
                                                        tabIndex={0}
                                                        onKeyDown={(e) => handleKeyDown(e, itemData)}
                                                        onClick={() => handleOpenItem(itemData)}

                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            cursor: 'pointer',
                                                            overflow: 'hidden',
                                                            borderRadius: 1, // theme.shape.borderRadius
                                                            // boxShadow: 2, // theme.shadows[2]
                                                            '&:hover': {
                                                                boxShadow: 2, // theme.shadows[2]
                                                            },
                                                            transition: 'all 0.3s ease',
                                                            height: '100%',
                                                            // minHeight: 200,
                                                            bgcolor: 'card.main',
                                                        }}
                                                        bgcolor={theme.palette.card.main}
                                                        borderRadius={theme.shape.borderRadius}
                                                    >
                                                        <ProgramCard
                                                            item={itemData}
                                                            // handleClick={() => handleOpenItem(itemData)}
                                                            handleClick={() => { }}
                                                            handleEditClick={() => handleOpenItemEdit(itemData)}
                                                            handleClickDelete={() => handleDeleteItem(itemData)}
                                                        />
                                                    </Box>
                                                )}
                                            />
                                        </Box>

                                    </>
                                )
                        )
                }
            </Box>

            {openCreateProgramDrawer && <CreateProgramComponent open={openCreateProgramDrawer} handleClose={handleCloseCreateDialog} handleContinue={handleCreateItem} />}
            {openEditProgramDrawer && currentProgramData && <EditProjectDrawer open={openEditProgramDrawer} handleClose={handleCloseItemEdit} handleContinue={handleUpdateProject} />}
            {openDeleteProgramDialog && <DeleteConfirmationDialog open={openDeleteProgramDialog} data={`${Entity_Label.programme}: ${currentProgramData?.name}`} handleContinue={() => handleDelete()} handleClose={handleCloseDeleteItem} />}

        </Box>
    )
}



function Header({ projectsList, isLoading, setIsLoading }) {

    const { headerSearchText, setHeaderSearchText } = useApplicationContext();
    const theme = useTheme();
    const errorHandler = useErrorHandler();
    const { t } = useTranslation('translation', { keyPrefix: 'project' });

    const [loading, setLoading] = useState(false);

    let timer;


    const handleChangeSearch = debounce((e) => {
        clearTimeout(timer);
        setLoading(true);
        setIsLoading(true)

        timer = setTimeout(() => {
            setHeaderSearchText(e.target.value);
            setLoading(false);
            setIsLoading(false)
        }, 1000);
    }, 300)





    return (
        <Box className="w-full h-full flex flex-col px-4 py-2 gap-4 " bgcolor={theme.palette.background.default} borderRadius={theme.shape.borderRadius}>

            {/* search / filter container */}
            <Box className="w-full h-fit flex items-center  gap-6">


                <Box className="h-full flex items-center justify-center " >
                    <TextField
                        fullWidth
                        type="search"
                        placeholder="Search"
                        // color="white"
                        // size="medium"

                        sx={{
                            // py: "6px",
                            // bgcolor: theme.palette.common.white,
                            // borderRadius: theme.shape.borderRadius,
                            // px: "4px",
                            // ":root" : {
                            //     bgcolor : theme.palette.common.white
                            // }
                            // background : theme.palette.common.white,
                            // '& .MuiInputBase-input': {
                            //     boxSizing: 'border-box',
                            //     border: "none",
                            //     // background: theme.palette.common.white,
                            // },
                            // '& .MuiOutlinedInput-notchedOutline': {
                            //     border: 'none'
                            // },
                            // '&:hover .MuiOutlinedInput-notchedOutline': {
                            //     border: 'none'
                            // },
                            // '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            //     border: 'none'
                            // }
                        }}
                        slotProps={{
                            input: {
                                startAdornment: <InputAdornment position="center">
                                    <Search />
                                </InputAdornment>,

                            }
                        }}
                        // defaultValue={headerSearchText}
                        onChange={handleChangeSearch}
                    />
                </Box>



            </Box>

        </Box>
    )
}
